import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=5a256445&"
import script from "./SelectCustom.vue?vue&type=script&lang=ts&"
export * from "./SelectCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports